import axiosInstance from "./axiosInstance";

export const checkFreeDemoRequest = () =>
  axiosInstance.get("/client/free-demo/request");

export const submitFreeDemoRequest = (data) =>
  axiosInstance.post("/client/free-demo/request", data);
